import React from 'react';
import { List, Datagrid, TextField, DateField, EditButton, BooleanField, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import { DatagridSX, ListSX } from '../../../styled/custom';
import CustomFilterDefault from '../../../filter/custom-filter-default';
import CustomListDefaultToolbar from '../../../ui/custom-list-default-toolbar';
import TypePlanExporter from '../../../exporter/type-plan-exporter';

const TypePlanList = (props) => (
  <List
    title="Tipos de Plano"
    sort={{ field: 'id', order: 'desc' }}
    filters={ CustomFilterDefault }
    exporter={ TypePlanExporter }
    actions={ <CustomListDefaultToolbar /> }
    sx={ListSX}>
    <Datagrid
      rowClick="show"
      bulkActionButtons={false}
      sx={DatagridSX}>
      <TextField source="id" sortable={false} />
      <TextField source="name" label="Nome" sortable={false} />
      <BooleanField source="has_audio" label="Áudio" sortable={false} />
      <BooleanField source="has_text" label="Texto" sortable={false} />
      <BooleanField source="has_video" label="Vídeo" sortable={false} />
      <ArrayField label="Categorias de Mídia" source="categories_media" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <BooleanField source="active" label="Ativo" sortable={false} />
      <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default TypePlanList;
